import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form, utils} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormBody, FormActions} = form;
import * as ciselnikActions from "../actions/ciselnikActions";
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu/úpravu fakturační položky.
 */
class FakturacniPolozkaForm extends Component<WithTranslation> {

    static formName = 'FakturacniPolozkaForm';

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchSazbyDphIfNeeded());
    };

    render() {
        const {onClose, submitting, handleSubmit, sazbyDphList, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('labels.name')} name="nazev" required disabled={submitting}/>
                <ff.String label={t('labels.PLU')} name="plu" required disabled={submitting}/>
                <ff.Number double label={t('labels.price')} name="cena" disabled={submitting}/>
                <ff.String label={t('labels.unit')} name="mj" disabled={submitting}/>
                <ff.Select label={t('labels.tax')} disabled={submitting} name="danId">
                    {sazbyDphList.rows.map((s)=><option key={'sazba_' + s.id} value={s.id}>{s.nazevDph}</option>)}
                </ff.Select>
                <CustomCheckboxField label={t('labels.inactive')} name="neaktivni" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

function mapStateToProps(state) {
    return {
        sazbyDphList: utils.storeFromArea(state, ciselnikActions.SAZBY_DPH_LIST_AREA),
    }
}

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: FakturacniPolozkaForm.formName,
})(FakturacniPolozkaForm)));
